import { Control, Controller, FieldError, FieldValues, Path } from 'react-hook-form';
import { Box, FormControl, FormHelperText, FormControlProps } from '@mui/material';

interface FormCustomProps<T extends FieldValues> extends Omit<FormControlProps, 'name'> {
  name: Path<T>;
  control: Control<T, any, any>;
  renderControl: (error?: FieldError) => React.ReactNode;
  hideHelperText?: boolean;
  ignoreFormControl?: boolean;
}

export const FormCustom = <T extends FieldValues>({
  name,
  control,
  renderControl,
  hideHelperText,
  ignoreFormControl = false,
}: FormCustomProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ fieldState: { error } }) => {
        const content = (
          <>
            {renderControl(error)}
            {!hideHelperText && error && <FormHelperText error>{error.message}</FormHelperText>}
          </>
        );

        if (ignoreFormControl) {
          return <Box data-rhf-field={String(name)}>{content}</Box>;
        }

        return (
          <FormControl error={!!error} fullWidth data-rhf-field={String(name)}>
            {content}
          </FormControl>
        );
      }}
    />
  );
}; 
